import { validateTokenApi } from "@/api/services/main/auth";
import { AppRoutes } from "@/routes/config";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

type UseValidateTokenParams = {
  resetToken?: string;
  email?: string;
  ownerId?: string;
};

export const useValidateToken = ({ resetToken, email, ownerId }: UseValidateTokenParams) => {
  const navigate = useNavigate();
  const [isValidatingToken, setIsValidatingToken] = useState(true);
  const [isTokenValid, setIsTokenValid] = useState(false);

  useEffect(() => {
    const validateToken = async () => {
      const redirectToNotFound = () => navigate(AppRoutes.pageNotFound, { replace: true });

      if (!email || !resetToken) {
        redirectToNotFound();
        return;
      }

      try {
        const response = await validateTokenApi({ resetToken, email });
        if (!response.valid) {
          throw new Error("Invalid token");
        }
        setIsTokenValid(true);
      } catch {
        redirectToNotFound();
      } finally {
        setIsValidatingToken(false);
      }
    };

    validateToken();
  }, [resetToken, email, ownerId, navigate]);

  return { isValidatingToken, isTokenValid };
};
